import { useSelector } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { selectActiveDsTab } from 'redux/mode/reducers';
import AllTokensView from './AllTokensView';
import ColorsView from './ColorsView';

const ThemeView = () => {
	const activeTab = useSelector((r: RootReducer) => selectActiveDsTab(r.mode));
	const contentPath = activeTab?.contentPath;

	if (contentPath === 'colors') {
		return <ColorsView />;
	}

	return <AllTokensView />;
};

export default ThemeView;
